import { defineStore } from 'pinia';
import { io } from 'socket.io-client';
import { ref } from 'vue'

import mitt from 'mitt';

import chalk from 'chalk';

import { useLoadingStore } from '@/stores/loadingStore.js';
const api_url = process.env.API_URL;

export const useSocketStore = defineStore('socketio', {
  state: () => ({
    host: `${api_url}`,
    authSocket: null,
    unauthSocket: null,
    isConnected: false,
    socketEvents: mitt(),
		success: ref(new Map()),
		error: ref(new Map()),
		pending: ref(new Map()),
  }),
  actions: {
		
    unauthConnect(){
      this.unauthSocket = io(`${this.host}/unauth`, {
        reconnect: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000, // milliseconds
        reconnectionDelayMax: 5000, // milliseconds
      });

      this.unauthSocket.onAny((eventName, ...args) => {
        console.log(`SocketIO ${chalk.cyan('Response')}: ${eventName}`);
        args.forEach((arg)=>
          console.log(arg)
        )
      });

      const emit = this.unauthSocket.emit;
      let sock = this.unauthSocket;
      this.unauthSocket.emit = function (eventName, ...args) {
        console.log(`SocketIO ${chalk.green('Request')}: ${eventName}`);
        args.forEach((arg)=>
          console.log(arg)
        )
        emit.call(sock, eventName, ...args);
      }; 

      this.unauthSocket.on('emailServiceReceived', (data) => {        
        this.socketEvents.emit('emailServiceReceived', data);
      });

      this.unauthSocket.on('emailServiceResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);

        this.socketEvents.emit('emailServiceResponse', data);
      });
    },
    connect(token) {
      this.authSocket = io(`${this.host}/auth`, {
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
        reconnect: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000, // milliseconds
        reconnectionDelayMax: 5000, // milliseconds
      });

      this.authSocket.onAny((eventName, ...args) => {
        console.log(`SocketIO ${chalk.cyan('Response')}: ${eventName}`);
        args.forEach((arg)=>
          console.log(arg)
        )
      });

      const emit = this.authSocket.emit;
      let sock = this.authSocket;
      this.authSocket.emit = function (eventName, ...args) {
        console.log(`SocketIO ${chalk.green('Request')}: ${eventName}`);
        args.forEach((arg)=>
          console.log(arg)
        )
        emit.call(sock, eventName, ...args);
      }; 

      this.authSocket.on('connect', () => {
        this.isConnected = true;
      });

      this.authSocket.on('disconnect', () => {
        this.isConnected = false;
      });

      this.authSocket.on('readyDocumentResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
        
        this.socketEvents.emit('readyDocumentResponse', data);
      });

      this.authSocket.on('readyDocumentReceived', (data) => {
        this.socketEvents.emit('readyDocumentReceived', data);
      });

      this.authSocket.on('eisPlanResponse', (data) => {
        this.socketEvents.emit('eisPlanResponse', data);
      });

      this.authSocket.on('eisPlanResponse', (data) => {
        this.socketEvents.emit('eisPlanResponse', data);
      });

      this.authSocket.on('notificationMapInvoiceItemsResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);

				if(data.error) {
					this.handleSocketError(data, data.upload_file_name, `Не удалось обработать УПД "${data.upload_file_name}"`, data.error)
				} else {
					this.handleSocketSuccess(data, data.upload_file_name, "УПД обработано", `УПД "${data.upload_file_name}" успешно обработано`)
				}
        console.log('notificationMapInvoiceItemsResponse');
        
        this.socketEvents.emit('notificationMapInvoiceItemsResponse', data);
      });
      this.authSocket.on('notificationEisContractsResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
				let isEisContractsByPeriod = data.date_from
				if(isEisContractsByPeriod) {
					// за период
						if(data.error) {
							this.handleSocketError(data, isEisContractsByPeriod, "Ошибка обработки договоров", data.error)
						} else {
							this.handleSocketSuccess(data, isEisContractsByPeriod, "Договоры успешно обработаны", `Договоры за период ${data.date_from}-${data.date_to} успешно обработаны и добавлены`)
						}					
				} else {
					// один договор
						if(data.error) {
							this.handleSocketError(data, data.eais_registry_number, data.error, data.violations.join('\n'))
						} else {
							this.handleSocketSuccess(data, data.eais_registry_number, "Договор успешно обработан", `Номер загруженного договора: ${data.eais_registry_number} `)
						}		
				}

        console.log('notificationEisContractsResponse');
        
        this.socketEvents.emit('notificationEisContractsResponse', data);
      });
      this.authSocket.on('notificationImportPaymentsResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
				if(data.error) {
					this.handleSocketError(data, data.upload_file_name, `Не удалось обработать платежное поручение "${data.upload_file_name}"`, data.error)
				} else {
					this.handleSocketSuccess(data, data.upload_file_name, "Платежное поручение обработано", `Платежное поручение "${data.upload_file_name}" успешно обработано`)
				}		
        this.socketEvents.emit('notificationImportPaymentsResponse', data);
      });
      this.authSocket.on('notificationPerfomanceContractResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);

				const registration_number = this.pending.get(data.performance_contract_guid)?.registration_number

				if(data.result === 'success') {
					this.handleSocketSuccess(data, data.performance_contract_guid, "Исполнение обработано", `Исполнение для договора "${registration_number}" успешно обработано`)	
				} else {
					this.handleSocketError(data, data.performance_contract_guid, `Не удалось обработать исполнение для договора "${registration_number}"`, data.error)	
				}
        this.socketEvents.emit('notificationPerfomanceContractResponse', data);
      });
			this.authSocket.on('reportCreateResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
				if(data.error) {
					this.handleSocketError(data, `${data.contract_guid}${data.report_code}`, `Не удалось создать отчёт для договора "${data.contract_regnumber}"`, data.error)
				} else {
					this.handleSocketSuccess(data, `${data.contract_guid}${data.report_code}`, "Отчёт успешно сформирован", `Отчёт для договора с регистрационным номером "${data.contract_regnumber}" успешно сформирован`)
				}		
        this.socketEvents.emit('reportCreateResponse', data);
      });
      this.authSocket.on('catalogUserfieldsResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
        
        this.socketEvents.emit('catalogUserfieldsResponse', data);
      });

      this.authSocket.on('documentUserfieldsReceived', (data) => {
        
      });

      this.authSocket.on('catalogUserfieldsReceived', (data) => {
        
      });

      this.authSocket.on('copyProcurementRuleReceived', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
        
        this.socketEvents.emit('copyProcurementRuleReceived', data);
      });

      this.authSocket.on('copyProcurementRuleResponse', (data) => {
        const loadingStore = useLoadingStore();
        loadingStore.setLoading(false);
        
        this.socketEvents.emit('copyProcurementRuleResponse', data);
      });
    },
    disconnect() {
      this.authSocket.disconnect();
      this.authSocket = null;
      this.isConnected = false;
    },
		handleSocketError(data, key, header, message, sentry = false) {
				if(!key) key = Math.floor(Math.random() * 1000000) + 1;
				if(header) data.header = header;
				if(message) data.message = message;
                if(sentry) data.sentry = sentry;
				this.pending.delete(`${key}`)
				this.error.set(`${key}`, data);
				setTimeout(() => {
						if(this.error.has(`${key}`)) {
								this.error.delete(`${key}`);
						}
				}, 10000);
		},
		handleSocketSuccess(data, key, header, message) {
				if(header) data.header = header;
				if(message) data.message = message;
				this.pending.delete(`${key}`)
				this.success.set(`${key}`, data);
				setTimeout(() => {
						if(this.success.has(`${key}`)) {
								this.success.delete(`${key}`);
						}
				}, 10000);
		},
		handleSocketPending(data, key) {
				this.pending.set(`${key}`, data);;
		},
    sendReadyDocumentRequest(message) {
      const loadingStore = useLoadingStore();
      loadingStore.setLoading(true);
      loadingStore.setLoadingMessage('socketReadyDocumentRequest');      

      this.authSocket.emit('readyDocumentRequest', message);
    },
    sendDocumentUserfieldsRequest(message) {
      const loadingStore = useLoadingStore();
      loadingStore.setLoading(true);
      loadingStore.setLoadingMessage('socketDocumentUserfieldsRequest');      

      this.authSocket.emit('documentUserfieldsRequest', message);
    },
    sendEmailRequest(message) {
      const loadingStore = useLoadingStore();
      loadingStore.setLoading(true);
      loadingStore.setLoadingMessage('sendEmailRequest');      

      this.unauthSocket.emit('emailServiceRequest', message);
    },
    sendCopyProcurementRule(message){
      const loadingStore = useLoadingStore();
      loadingStore.setLoading(true);
      loadingStore.setLoadingMessage('socketCopyProcurementRule');

      this.authSocket.emit('copyProcurementRuleRequest', message);
    }
  },
});